import { PRODUCT_CATEGORY_V1, PRODUCT_CATEGORY_V2 } from "./constants";

export const getProductCategoryByVersion = (storeLocatorLayoutVersion: string): string => {
  return storeLocatorLayoutVersion === "v1" ? PRODUCT_CATEGORY_V1 : PRODUCT_CATEGORY_V2;
};
